import { EventType } from '@/analytics/types';

import { EidHeroBackground } from './common/EidHeroBackground';
import HolidayHeroTemplate25 from './HolidayHeroTemplate25';

const EidCampaignHero = () => {
  return (
    <HolidayHeroTemplate25
      Background={EidHeroBackground}
      titleMsgKey="30_off_oura_ring_4"
      subcopyMsgKey="eid_hero_copy"
      buttonProps={{
        href: '/store',
        ctaLabel: 'call_to_action_button_text',
        onClick: () => {
          void window.ouraAnalytics.track(EventType.CTAClicked, {
            cta: 'shop now',
            action: 'go to store',
            location: 'home hero',
            path: '/store',
          });
        },
      }}
      dataCy="eid-campaign-hero"
    />
  );
};

export default EidCampaignHero;
